<template>
  <div>
    <button class="btn btn-light" @click="showModal">
      <i class="mr-2 fas fa-link" aria-hidden="true" />

      <span>Dodaj z Mdok</span>
    </button>

    <add-from-mdok-modal :show="modalVisible" @save="save($event)" @close="hideModal" />
  </div>
</template>

<script>
import AddFromMdokModal from '@/components/modals/AddFromMdokModal';
import { AttachmentType } from '@/enums/attachmentType.enum';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Upload załącznika z mdok
// @group Attachment
export default {
  components: {
    AddFromMdokModal
  },
  mixins: [notificationsMixin],
  props: {
    // Typ encji
    entityType: { type: String, required: true },
    // Id encji
    entityId: { type: String, required: true },
    // Typ załącznika
    attachmentType: { type: String, required: false, default: AttachmentType.UPLOADED },
    // Dodatkowe metadata do załącznika
    additionalMetadata: { type: Object, required: false, default: undefined }
  },
  data() {
    return {
      modalVisible: false
    };
  },

  methods: {
    // @vuese
    // Pokazuje modal do dodania dokumentu z mdok
    showModal() {
      this.modalVisible = true;
    },
    // @vuese
    // Ukrywa modal dodawania
    hideModal() {
      this.$set(this, 'modalVisible', false);
    },
    // @vuese
    // Zapisuje wybrany dokument
    save(model) {
      this.$store
        .dispatch(`${this.entityType}/attachment/attachmentAddFromMdok`, {
          uid: model.uid,
          entityType: this.entityType,
          entityId: this.entityId,
          attachmentType: this.attachmentType,
          additionalMetadata: this.additionalMetadata
        })
        .then(id => {
          const addedAttachment = this.$store.getters[this.entityType + '/attachment/byId'](id);
          this.$emit('attachmentAdded', addedAttachment);
          this.notifySuccess(Successes.ATTACHMENT_SAVED);
          this.hideModal();
        })
        .catch(() => this.notifyError(Errors.ATTACHMENT_CANNOT_SAVE));
    }
  }
};
</script>
